<div
  class="card card-shadow"
  [class.bg-grey]="isSubmitDisabled && payrollStartData?.ActivePayroll?.PayType != 5">
  <div class="card-body d-flex flex-column">
    <h3 class="card-title">Calculate & Record a Pay</h3>
    <ng-container *ngIf="isTileDisabled; then no_functionality; else payroll"> </ng-container>
    <ng-template #no_functionality>
      We are not quite ready for manual payrolls. We will let you know when new functionality is
      available. For now, please enter this client's manual payroll in the APS system.
    </ng-template>
    <ng-template #payroll>
      <h6>
        Planning to pay someone outside of payroll? Here you can calculate figures and record them
        for tax and accounting purposes in the next payroll run.
      </h6>
      <div *ngIf="payrollStartData?.ActivePayroll?.PayType == 5">
        <h6 class="cp-green fw-bold mb-0">Entry in progress</h6>
        <small class="cp-green">
          Last edit by {{ payrollStartData?.ActivePayroll?.LastEditBy }} on
          {{ payrollStartData?.ActivePayroll?.LastEditOn | date: 'MM/dd/yyyy h:mma' }}
        </small>
      </div>
      <div class="row mt-auto">
        <div class="col d-flex justify-content-end align-items-center">
          <button
            type="button"
            cpGTagEvent
            [params]="{
              event_label: payrollStartData?.ActivePayroll
                ? 'manual_payroll_tile_resume'
                : 'manual_payroll_tile_start'
            }"
            [disabled]="isSubmitDisabled"
            class="btn btn-primary float-end mt-4"
            (click)="navigatePayroll()"
            data-testid="manual-payroll-tile-btn">
            {{ payrollStartData?.ActivePayroll?.PayType == 5 ? 'Resume' : 'Calculate Pay' }}
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
